import React from "react";
import { Widget, WidgetProps } from "@rjsf/utils";

export const ParagraphWidget: Widget = ({ label }: WidgetProps) => {
  return <p className="form-text">{label}</p>;
};
